import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';

import ItemImageOverlay from './ItemImageOverlay';

import './PackItemImage.scss';

@observer
export default class PackItemImage extends Component {
	static propTypes = {
		imageUrl: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
	};

	@observable canShow = false;

	@action
	toggle(show) {
		this.canShow = show;
	}

	imageUrl = this.props.imageUrl;
	name = this.props.name;

	render() {
		return (
			<span className="PackItemImage">
				<img
					className="image"
					src={this.imageUrl}
					alt={this.name}
					id="ItemImage"
					onMouseOver={this.toggle.bind(this, true)}
					onMouseLeave={this.toggle.bind(this, false)}
				/>
				<ItemImageOverlay
					show={this.canShow}
					imageUrl={this.imageUrl}
					name={this.name}
				/>
			</span>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/PackItemImage/index.js